import {customAxios} from "../customAxios";
import {useState} from "react";
import {LeasePackageImportDto, LeasePackageMultiImportDto, LeasePackageMultiImportSimpleDto} from "../../model/Imports";

export function useGetMultiImport() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<LeasePackageMultiImportDto>();
    const [error, setError] = useState<Error>();

    async function execute(importId: string) {
        try {
            setLoading(true);
            setError(undefined);
            const data = await getMultiImport(importId);
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, data, error, execute
    };
}

export async function getMultiImport(importId: string): Promise<LeasePackageMultiImportDto> {
    const response = await customAxios.get<LeasePackageMultiImportDto>(`/v1/lease-packages/import/multi/${importId}`, );
    return response.data;
}

